import CardSeplag from "../../../../../components/CardSeplag";
import ModalSeplag from "../../../../../components/ModalSeplag";
import { PickList } from "primereact/picklist";
import { useState } from "react";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import RotuloSeplag from "../../../../../components/RotuloSeplag";
import { RadioButton } from "primereact/radiobutton";
import { InputMask } from "primereact/inputmask";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { createProrrogacao } from "../../../../../service/Rag/Exercicio";
const CadastroProrrogacao = ({
  exercicio,
  programaSelected,
  cronograma,
  programasList,
  indicadoresList,
  acoesList,
  visibleCadastroProrrogacao,
  setVisibleCadastroProrrogacao,
  setAtualizaList,
}) => {
  const [sourceProgramaList, setSourceProgramaList] = useState(programasList);
  const [sourceIndicadoresList, setSourceIndicadoresList] = useState(indicadoresList);
  const [sourceAcoesList, setSourceAcoesList] = useState(acoesList);
  const [targetProgramaList, setTargetProgramaList] = useState([]);
  const [targetIndicadoresList, setTargetIndicadoresList] = useState([]);
  const [targetAcoesList, setTargetAcoesList] = useState([]);
  const [dataInicial, setDataIncial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [checkAcoes, setCheckAcoes] = useState([]);

  const onChangeProgramas = (event) => {
    setSourceProgramaList(event.source);
    setTargetProgramaList(event.target);
  };
  const onChangeIndicadores = (event) => {
    setSourceIndicadoresList(event.source);
    setTargetIndicadoresList(event.target);
  };
  const onChangeAcoesList = (event) => {
    setSourceAcoesList(event.source);
    setTargetAcoesList(event.target);
  };
  const itemTemplateAcoes = (item) => {
    return (
      <>
        <div className="picklist-item">
          <div className="picklist-list-detail">
            <span className="picklist-category">{item.ptaFiplan.descricaoFiplan}</span>
          </div>
        </div>
      </>
    );
  };
  const itemTemplateIndicadores = (item) => {
    return (
      <>
        <div className="picklist-item">
          <div className="picklist-list-detail">
            <span className="picklist-category">{item.codgIndicador + " - " + item.descIndicador}</span>
          </div>
        </div>
      </>
    );
  };
  const itemTemplateProgramas = (item) => {
    return (
      <>
        <div className="picklist-item">
          <div className="picklist-list-detail">
            <span className="picklist-category">{item.descricaoFiplan}</span>
          </div>
        </div>
      </>
    );
  };

  const salvarProrrogacoes = async () => {
    let dadosProrrogacao = {
      exercicio: exercicio,
      cronograma: cronograma,
      programa: programaSelected,
      descProrrogacao: "",
      programas: targetProgramaList,
      ptaMonitoras: targetAcoesList,
      indicadores: targetIndicadoresList,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
    };

    if (dataInicial === "" || dataFinal === "") {
      return window.$toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Data  informada invalida !",
      });
    }

    if (Date(dataInicial) > Date(dataFinal)) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Data  informada invalida !",
      });
    }

    await createProrrogacao(dadosProrrogacao).then((res) => {
      if (res.status === 200) {
        window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
        setVisibleCadastroProrrogacao(false);
        setAtualizaList(true);
      }
    });
  };

  return (
    <ModalSeplag
      titulo="Cadastro de Prorrogação"
      tamanho="1200px"
      type="NONE"
      visible={visibleCadastroProrrogacao}
      fechar={() => {
        setVisibleCadastroProrrogacao(false);
      }}
    >
      <CardSeplag>
        <Splitter>
          <SplitterPanel size={80}>
            {programasList != null && ["P"].includes(cronograma.tipoItemRag) && (
              <PickList
                source={sourceProgramaList}
                target={targetProgramaList}
                showTargetControls={false}
                showSourceControls={false}
                itemTemplate={itemTemplateProgramas}
                sourceStyle={{ height: "342px" }}
                targetStyle={{ height: "342px" }}
                onChange={onChangeProgramas}
              />
            )}
            {indicadoresList != null && ["I"].includes(cronograma.tipoItemRag) && (
              <PickList
                source={sourceIndicadoresList}
                target={targetIndicadoresList}
                showTargetControls={false}
                showSourceControls={false}
                itemTemplate={itemTemplateIndicadores}
                sourceStyle={{ height: "342px" }}
                targetStyle={{ height: "342px" }}
                onChange={onChangeIndicadores}
              />
            )}
            {acoesList != null && ["A"].includes(cronograma.tipoItemRag) && (
              <PickList
                source={sourceAcoesList}
                target={targetAcoesList}
                showTargetControls={false}
                showSourceControls={false}
                itemTemplate={itemTemplateAcoes}
                sourceStyle={{ height: "342px" }}
                targetStyle={{ height: "342px" }}
                onChange={onChangeAcoesList}
              />
            )}
          </SplitterPanel>
          <SplitterPanel>
            <Panel header="Período da prorrogação">
              <RotuloSeplag nome="Data Inicial" cols="4">
                <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" onChange={(e) => setDataIncial(e.target.value)} />
              </RotuloSeplag>
              <RotuloSeplag nome="Data Final" cols="4">
                <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" onChange={(e) => setDataFinal(e.target.value)} />
              </RotuloSeplag>
              {/* {cronograma.tipoItemRag === "P" && (
                <RotuloSeplag nome="Aplicar para as ações?" cols="12" style={{ display: "center" }}>
                  <RadioButton
                    checked={checkAcoes === "S"}
                    name="checkAcoes"
                    value="S"
                    onChange={(e) => setCheckAcoes(e.value)}
                  />
                  Sim
                  <RadioButton
                    checked={checkAcoes === "N"}
                    name="checkAcoes"
                    value="N"
                    onChange={(e) => setCheckAcoes(e.value)}
                  />
                  Não
                </RotuloSeplag>
              )} */}
            </Panel>
          </SplitterPanel>
        </Splitter>

        <div className="field col-12 md:col-12" style={{ marginTop: "1rem" }}>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-3 "></div>
            <div className="field col-12 md:col-3 ">
              <Button type="submit" label="Salvar" className="salvar" onClick={salvarProrrogacoes} />
            </div>
            <div className="field col-12 md:col-3 ">
              <Button
                label="Fechar"
                className="voltar p-button-danger"
                onClick={() => {
                  setVisibleCadastroProrrogacao(false);
                }}
              />
            </div>
          </div>
        </div>
      </CardSeplag>
    </ModalSeplag>
  );
};
export default CadastroProrrogacao;
